/* eslint-disable prettier/prettier */
import XLSX from 'xlsx';

class invoiceTemplate {
  constructor() {}

  summary = {
    companyName: 'DAI MI VN CO., LTD',
    companyAddress:
      '                              66/2, Lien Khu 2-5 St,  Binh Tri Dong Ward, Binh Tan District, Ho Chi Minh City, VietNam',
    companyContact: '      Tel: (84)028- 66828806                       Mobile: 090.886.8806( Q.Vinh)',
    buyer: 'BUYER :MILES FASHION ASIA PTE LTD',
    buyerAddress: '1 Kallang Junction, #05-01, Singapore',
    invoiceNo: '123456',
    date: '20/12/2010',
    from: 'FROM: DAI MI VN CO., LTD',
    to: 'TO: MILES FASHION ASIA PTE LTD'
  };

  data() {
    return [
      [this.summary.companyName, '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
      [this.summary.companyAddress, '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
      [this.summary.companyContact, '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
      ['INVOICE', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
      [
        this.summary.buyer,
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        'INVOICE NO:',
        '',
        this.summary.invoiceNo,
        '',
        'DATE',
        this.summary.date,
        '',
        ''
      ],
      [this.summary.buyerAddress, '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
      [],
      [this.summary.from],
      [this.summary.to],
      [
        'Ngày xuất hàng',
        'Mã phiếu xuất',
        'Tên sản phẩm',
        'Mã sản phẩm',
        'Màu sắc',
        'Mã màu',
        'Quy cách',
        '',
        'Chiều dài',
        'Số lượng',
        'ĐVT',
        'Đơn Giá',
        'Thành tiền',
        'Loại tiền',
        'Số Hóa đơn',
        'Công ty nhận hàng',
        'Người đặt hàng',
        ''
      ],
      [
        'Date',
        'Code',
        'Product Name',
        'Product Code',
        'Color',
        'Color code',
        'Size',
        '',
        'Length',
        'Quantity',
        'Unit',
        'Unit Price',
        'Amount',
        'Currency',
        'Invoice Number',
        'Receiver',
        'Orderer',
        'Style No'
      ]
    ];
  }

  init(buyer = '', buyerAddress = '', invoiceNo = '', date = '', to = '') {
    this.summary.buyer = buyer;
    this.summary.buyerAddress = buyerAddress;
    this.summary.invoiceNo = invoiceNo;
    this.summary.date = date != '' ? date : new Date().toLocaleDateString();
    this.summary.to = to;

    let data = this.data();
    var worksheet = XLSX.utils.aoa_to_sheet(data);
    if (!worksheet['!merges']) worksheet['!merges'] = [];
    worksheet['!merges'].push({ s: { r: 0, c: 0 }, e: { r: 0, c: 17 } });
    worksheet['!merges'].push({ s: { r: 1, c: 0 }, e: { r: 1, c: 17 } });
    worksheet['!merges'].push({ s: { r: 2, c: 0 }, e: { r: 2, c: 17 } });
    worksheet['!merges'].push({ s: { r: 3, c: 0 }, e: { r: 3, c: 17 } });

    worksheet['!merges'].push({ s: { r: 4, c: 0 }, e: { r: 4, c: 4 } });
    worksheet['!merges'].push({ s: { r: 5, c: 0 }, e: { r: 5, c: 17 } });
    worksheet['!merges'].push({ s: { r: 9, c: 6 }, e: { r: 9, c: 7 } });
    // worksheet['!merges'].push({ s: { r: 10, c: 3 }, e: { r: 10, c: 4 } });
    worksheet['!merges'].push({ s: { r: 10, c: 6 }, e: { r: 10, c: 7 } });
    // this.add_cell_to_sheet(worksheet, "D5", 10);
    // XLSX.utils.sheet_add_aoa(worksheet, this.excelData.data, { origin: -1 });

    return worksheet;
  }
}
export default new invoiceTemplate();
